module.exports = __webpack_public_path__ + "img/martina-glauninger.1479178b.jpg";